// This whole file is a hack to match the expected interface when passing
// context to the ReactRailsUJS.useContext fn. The issue this is trying to fix
// is that mapping components (jsx files) to render calls in react views was
// failing due to file extensions being included. This strips them so the match
// works and we can easily move to typescript extensions by modifying this file.

const rawContext = require.context(".", true, /\.(jsx?|tsx?)$/)

// Strip extensions for normalized lookup
function normalizedContext(key) {
  const extensions = [".tsx", ".ts", ".jsx", ".js"]

  for (const ext of extensions) {
    try {
      return rawContext(key + ext)
    } catch (e) {
      // continue trying
    }
  }

  throw new Error(`Component not found: ${key}`)
}

normalizedContext.keys = () =>
  rawContext.keys().map((key) => key.replace(/\.(jsx?|tsx?)$/, ""))

normalizedContext.resolve = (key) => {
  const extensions = [".tsx", ".ts", ".jsx", ".js"]

  for (const ext of extensions) {
    try {
      return rawContext.resolve(key + ext)
    } catch (e) {
      // no-op
    }
  }

  throw new Error(`Component not found: ${key}`)
}

export default normalizedContext
